import { OneTouchSwitchButtonT } from '@components/Organisms/OneTouchSwitchButton/types';
import React, { FC } from 'react';
import { StyledOneTouchSwitchButton } from '@components/Organisms/OneTouchSwitchButton/styled/StyledOneTouchSwitchButton';
import Image from 'next/image';
import { ButtonType } from '@components/Atoms/Button/types';
import { Button } from '@components/Atoms';

export const OneTouchSwitchButton: FC<OneTouchSwitchButtonT> = ({
  title,
  boxHeader,
  description,
  image,
  button,
  display,
}) => {
  if (!display) return null;

  return (
    <StyledOneTouchSwitchButton>
      <h2>{title}</h2>
      <div className="box">
        <h3>{boxHeader}</h3>
        <div className="md:flex md:flex-row md:items-center md:gap-10">
          {image?.url && (
            <div className="img-wrapper">
              <Image src={image.url} width={image.width} height={image.height} alt={title} />
            </div>
          )}
          <p>{description}</p>
        </div>
        {button && (
          <Button buttonType={ButtonType.SIMPLEBLUE} as="a" href={button.link}>
            {button.label}
          </Button>
        )}
      </div>
    </StyledOneTouchSwitchButton>
  );
};
